import React from 'react';

type DesktopProductFrameProps = {
  children: React.ReactNode;
  title?: string;
  className?: string;
  mediaClassName?: string;
};

type PhoneShellFrameProps = {
  children: React.ReactNode;
  className?: string;
  mediaClassName?: string;
};

export const DesktopProductFrame: React.FC<DesktopProductFrameProps> = ({
  children,
  title = 'intelgrader.com',
  className = '',
  mediaClassName = '',
}) => {
  return (
    <div className={`product-shell product-shell--desktop ${className}`.trim()}>
      <div className="product-shell__desktop-screen">
        <div className="product-shell__titlebar">
          <svg className="product-shell__traffic" width="54" height="14" viewBox="0 0 54 14" fill="none" aria-hidden="true">
            <circle cx="7" cy="7" r="5.5" fill="#FF5F57" stroke="#E0443E" strokeWidth="0.5" />
            <circle cx="27" cy="7" r="5.5" fill="#FEBC2E" stroke="#DEA123" strokeWidth="0.5" />
            <circle cx="47" cy="7" r="5.5" fill="#28C840" stroke="#1AAB29" strokeWidth="0.5" />
          </svg>
          <span className="product-shell__title">{title}</span>
        </div>
        <div className={`product-shell__desktop-media ${mediaClassName}`.trim()}>
          {children}
        </div>
        <div className="product-shell__desktop-vignette" />
      </div>
      <div className="product-shell__desktop-base" aria-hidden="true">
        <div className="product-shell__desktop-trackpad" />
      </div>
    </div>
  );
};

export const PhoneShellFrame: React.FC<PhoneShellFrameProps> = ({
  children,
  className = '',
  mediaClassName = '',
}) => {
  return (
    <div className={`product-shell product-shell--phone ${className}`.trim()}>
      <div className="product-shell__phone-body">
        <div className="product-shell__phone-camera" aria-hidden="true" />
        <div className={`product-shell__phone-screen ${mediaClassName}`.trim()}>
          {children}
        </div>
      </div>
    </div>
  );
};
